/*
  NOTE: Reactフォーム（StepProvider）で使用される実際のURLパスとchannel値のマッピング処理の暫定対応です

  ## どこと同じであるべきか？
  - 以下Salesforceのエントリーサイトへのリンクを参照し、このテーブルにおけるURL列とサイト列の対応と同じであるべきです

  ## 今この状態でどういうリスクがあるか？
  - application_helper.rbのget_channel_from_pathメソッドに定義してあるマッピングが、すでにSalesforceのエントリーサイトの情報と完全に同期していない可能性があります
  - application_helper.rbのget_channel_from_pathメソッドでは既存のERBページのフォームで使用されるマッピングを定義しており、SP版のReactフォームで使用されるマッピングはこのファイル（REACT_FORM_PATH_TO_CHANNEL_MAP）で別途定義しています
  - Salesforceのエントリーサイト上のURL列とサイト列の対応が変更された場合、application_helper.rbのget_channel_from_pathメソッドとこのREACT_FORM_PATH_TO_CHANNEL_MAPを適宜手動で更新する必要があります

  ## 今後どうするつもりか？
  - Salesforceのフォームハンドラー剥がしが完了し次第、登録処理をPFのサーバー側で一元的に担うようにし、マッピングに関しても一元的に管理するようにする予定です
  - その際、application_helper.rbのget_channel_from_pathメソッドとこのREACT_FORM_PATH_TO_CHANNEL_MAPを統合し、一箇所で管理するようにします

  ## 関連ファイル
  - app/helpers/application_helper.rb#get_channel_from_path（ERB用マッピング）
  - app/javascript/components/utils/channelMappingUtils.ts（React用マッピング）

  ## 参考リンク
  foodslabo-pf-ag/app/helpers/application_helper.rbへのパーマネントリンク
  https://github.com/foodslabo/foodslabo-pf-ag/blob/63d74fbfada44075aabb063622e2e233f025609b/app/helpers/application_helper.rb#L210

  Salesforceのエントリーサイトへのリンク
  https://d5i000007d96leac.lightning.force.com/lightning/o/EntryWebSite__c/list?filterName=All
*/

const REACT_FORM_PATH_TO_CHANNEL_MAP: { [key: string]: string } = {
  // foodslabo Google検索系
  '/all/sp/': 'SLP',
  '/lp/sp/': 'SLP',
  '/kansai/sp/': 'SLP',
  '/fukuoka/sp/': 'SLP',
  '/sendai/sp/': 'SLP',
  '/sapporo/sp/': 'SLP',
  '/nagoyalp/sp/': 'SLP',
  '/shizuoka/sp/': 'SLP',
  '/northern_kanto/sp/': 'SLP',
  '/nagano/sp/': 'SLP',
  '/nagasaki/sp/': 'SLP',
  '/hiroshima/sp/': 'SLP',
  '/hiroshima/': 'SLP',
  '/okinawa/sp/': 'SLP',
  '/okinawa': 'SLP',

  // foodslabo DSP系
  '/dsp/sp/': 'SLPDSP',
  '/dsp_kansai/sp/': 'SLPDSP',
  '/dsp_sapporo/sp/': 'SLPDSP',
  '/dsp_fukuoka/sp/': 'SLPDSP',
  '/dsp_nagoya/sp/': 'SLPDSP',
  '/dsp_sendai/sp/': 'SLPDSP',
  '/dsp_shizuoka/sp/': 'SLPDSP',
  '/dsp_northern_kanto/sp/': 'SLPDSP',
  '/dsp_hiroshima/sp/': 'SLPDSP',

  // foodslabo Instagram系
  '/instagram-column_lp/sp/': 'SLPインスタ',
  '/instagram-column_lp_ks/sp/': 'SLPインスタ',
  '/instagram-column_lp_fukuoka/sp/': 'SLPインスタ',
  '/instagram-column_lp_nagoya/sp/': 'SLPインスタ',
  '/instagram-column_lp_sapporo/sp/': 'SLPインスタ',
  '/instagram-column_lp_shizuoka/sp/': 'SLPインスタ',
  '/instagram-column_lp_northern_kanto/sp/': 'SLPインスタ',
  '/instagram-column_lp_sendai/sp/': 'SLPインスタ',
  '/instagram-column_lp_okinawa/sp/': 'SLPインスタ',
  '/instagram-column_lp_okinawa/': 'SLPインスタ',
  '/instagram-column_lp_nagano/sp/': 'SLPインスタ',
  '/instagram-column_lp_nagano/': 'SLPインスタ',
  '/instagram-column_lp_nagasaki/sp/': 'SLPインスタ',
  '/instagram-column_lp_nagasaki/': 'SLPインスタ',
  '/instagram_organic/': 'インスタ_オーガニック',

  // foodslabo Yahoo系
  '/yahoo/': 'Yahoo',

  // foodslabo Geniee系
  '/geniee/sp/': 'SLPGENIEE',
  '/geniee_line/sp/': 'SLPGENIEE LINE',

  // foodslabo Line系
  '/line/': 'LINE',
  '/line/sp/': 'LINE',

  // foodslabo Affiliate系
  '/af/sp/': 'SLPアフィ',
  '/seg/sp/': 'SLPセグメント',
  '/vc/sp/': 'SLPバリュー',
  '/ren/sp/': 'SLPレントラ',

  // foodslabo Kyujinbox系
  '/lp/kyujinbox/': '求人ボックス_AG求人',

  // foodslabo IntroductionLP系
  '/introduction_lp/sp/': 'SP知人紹介',

  // hotelslabo Google検索系
  '/hotels/google_adwords/sp/': 'ホテル_SP',
  '/hotels/google_adwords_kansai/sp/': 'ホテル_GA',
  '/hotels/google_adwords_fukuoka/sp/': 'ホテル_GA',
  '/hotels/google_adwords_nagoya/sp/': 'ホテル_GA',
  '/hotels/google_adwords_sapporo/sp/': 'ホテル_GA',

  // hotelslabo Instagram系
  '/hotels/instagram/sp/': 'ホテル-インスタ',
  '/hotels/instagram_kansai/sp/': 'ホテル-インスタ',
  '/hotels/instagram_fukuoka/sp/': 'ホテル-インスタ',
  '/hotels/instagram_nagoya/sp/': 'ホテル-インスタ',
  '/hotels/instagram_sapporo/sp/': 'ホテル-インスタ',

  // hotelslabo TikTok系
  '/hotels/tiktok_smart_plus/': 'ホテル_TikTok_smart_plus',
  '/hotels/tiktok_kansai/': 'ホテル-TikTok',
  '/hotels/tiktok_sapporo/': 'ホテル-TikTok',
  '/hotels/tiktok_nagoya/': 'ホテル-TikTok',
  '/hotels/tiktok_fukuoka/': 'ホテル-TikTok',
  '/hotels/tiktok/': 'ホテル-TikTok',

  // hotelslabo Yahoo系
  '/hotels/yahoo/': 'ホテル-Yahoo',

  // hotelslabo Geniee系
  '/hotels/geniee/sp/': 'SLPホテルGENIEE',
  '/hotels/geniee_line/sp/': 'SLPホテルGENIEE LINE',

}

// パフォーマンス最適化: 事前にソート済み配列を作成（長いパスを優先）
const SORTED_PATH_MAPPINGS = Object.entries(REACT_FORM_PATH_TO_CHANNEL_MAP)
  .sort(([a], [b]) => b.length - a.length)

/**
 * 現在のURLパスからchannel値を判定する
 * /registerパスにも対応するため部分マッチング方式を使用
 *
 * @param path URLパス（省略時は現在のpathnameを使用）
 * @returns channel値（マッピングがない場合は'HP'をデフォルト値として返す）
 */
export const getChannelFromPath = (path?: string): string => {
  let currentPath = path || window.location.pathname

  if (currentPath !== '/' && !currentPath.endsWith('/')) {
    currentPath = currentPath + '/'
  }

  // 完全一致を先にチェック
  const exactMatch = REACT_FORM_PATH_TO_CHANNEL_MAP[currentPath]
  if (exactMatch !== undefined) {
    return exactMatch
  }

  // 部分一致をチェック（/registerパス対応）
  for (const [pathPattern, channelValue] of SORTED_PATH_MAPPINGS) {
    if (currentPath.startsWith(pathPattern)) {
      return channelValue
    }
  }

  // デフォルト値（Rails版のget_channel_from_pathと合わせる）
  return 'HP'
}